import get from 'lodash/get';

export const getListingPhone = listing => {
  return get(listing, 'attributes.publicData.listing_phone_number', null);
};

export const getListingPhoneValue = listing => {
  return get(getListingPhone(listing), 'phone.value', null);
};

export const getListingId = listing => {
  return get(listing, 'id.uuid', null);
}
